import { Stack, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Tab } from '@feathr/components';
import Page from '@feathr/extender/App/Page';
import { getIconForAction } from '@feathr/hooks';

import GoalDrawer from './GoalDrawer';
import GoalManagerStats from './GoalManagerStats';
import GoalManagerTable from './GoalManagerTable';
import { useGoalManagerPage } from './ReportsConversionsGoalManagerPage.hooks';
import { hasAnyGoals } from './ReportsConversionsGoalManagerPage.utils';

function ReportsConversionsGoalManagerPage(): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const {
    activeCount,
    archivedCount,
    filteredGoals,
    goals,
    kind,
    search,
    setKind,
    setSearch,
    setTab,
    tab,
  } = useGoalManagerPage();

  function handleCampaigns(): void {
    setKind('campaign');
  }

  function handleFlights(): void {
    setKind('flight');
  }

  const [isDrawerOpen, { open: openDrawer, close: closeDrawer }] = useDisclosure(false);

  return (
    <Page
      actions={[
        <Button
          key={'create-goal'}
          onClick={openDrawer}
          prefix={getIconForAction('add')}
          type={'primary'}
        >
          {t('Create goal')}
        </Button>,
      ]}
      collapseHeader={false}
      tabs={[
        <Tab
          active={kind === 'campaign'}
          key={'campaigns'}
          onClick={handleCampaigns}
          title={t('Campaigns')}
        />,
        <Tab
          active={kind === 'flight'}
          key={'flights'}
          onClick={handleFlights}
          title={t('Flights')}
        />,
      ]}
      title={t('Goal Manager')}
    >
      <Stack gap={theme.spacing['6']}>
        {hasAnyGoals(goals) && (
          <GoalManagerStats activeCount={activeCount} archivedCount={archivedCount} />
        )}
        <GoalManagerTable
          filteredGoals={filteredGoals}
          goals={goals}
          search={search}
          setSearch={setSearch}
          setTab={setTab}
          tab={tab}
        />
      </Stack>
      <GoalDrawer isOpen={isDrawerOpen} onClose={closeDrawer} />
    </Page>
  );
}

export default observer(ReportsConversionsGoalManagerPage);
